import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useQueryClient } from "react-query";
import { usePost } from "../../hooks/usePost";
import {
  setAuthCookie,
  setUserDetailsCookie,
  setUsernameCookie,
} from "../../utils/auth";
import { routes } from "../../utils/constants/route";

export default function useLoginLogic() {
  const [open, setOpen] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const onErrorCall = (error) => {
    setNotificationMessage(error?.response?.data?.data || error.message);
    setOpen(true);
  };

  const onSuccessFulCall = (data) => {
    const dataToSave = data?.data?.data;
    queryClient.setQueryData("login", data, {
      cacheTime: 10000,
      staleTime: 10000,
    });
    setAuthCookie(`Bearer ${dataToSave?.authToken?.accessToken}`);
    setUsernameCookie(dataToSave?.username);
    delete dataToSave["authToken"];
    setUserDetailsCookie(dataToSave);
    navigate(`/${routes.USER.at(0).id}`);
  };

  const { mutate, isLoading, isError, data, error } = usePost(
    onSuccessFulCall,
    onErrorCall
  );
  const onSubmit = (values, _event) => {
    const loginData = { username: values.username, password: values.password };
    mutate({ url: `login`, data: loginData, method: "post" });
  };

  const handleClose = (_event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return {
    state: {
      register,
      errors,
      open,
      notificationMessage,
    },
    handlers: { handleSubmit, handleClose, onSubmit },
    fetchResponse: {
      isLoading,
      isError,
      data,
      error,
    },
  };
}
